import { render } from "./IconMediaFileWarning.vue?vue&type=template&id=084b392b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMediaFileWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "084b392b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('084b392b', __exports__)) {
    api.reload('084b392b', __exports__)
  }
  
  module.hot.accept("./IconMediaFileWarning.vue?vue&type=template&id=084b392b", () => {
    api.rerender('084b392b', render)
  })

}


export default __exports__